
export const setNoScroll = () => {
    document.body.classList.replace("scroll","no-scroll");
}

export const setScroll = () => {
    // console.log("scroll");
    document.body.classList.replace("no-scroll","scroll");
}